<template>
  <div v-bind="$attrs" class="support-chat">
    <div
      v-if="!initialFetchComplete"
      class="loading width-expand flex-middle flex-center"
      style="height: 300px">
      <spinner :size="3"></spinner>
    </div>

    <div v-if="!finalConversationUuid && initialFetchComplete" class="start-chat-ui">
      <h4>
        {{ translateUcFirst("chat.support.title") }}
      </h4>
      <div class="start-ui">
        <div class="flex gap-m flex-middle flex-wrap width-expand padding-bottom">
          <form-input
            v-model="initialMessageText"
            class="message-input width-expand"
            :label="false"
            placeholder="chat.message.sendUi.contentPlaceholder"
            style="min-height: 0px"
            type="textarea"
            @keyup.enter="startSupportChat()"></form-input>

          <form-button
            class="message-send-cta"
            icon-end="chevron-inline-end"
            text="chat.message.sendUi.sendCta"
            @click="startSupportChat()"></form-button>
        </div>
      </div>
    </div>

    <chat-component v-if="finalConversationUuid && initialFetchComplete"
          :conversation-uuid="finalConversationUuid"
          class="width-expand"></chat-component>

  </div>
</template>

<script>
import useChat from "@/client/extensions/composition/useChat";
import asyncOperations from "@/client/extensions/composition/asyncOperations";

import ChatComponent from "@/client/components/chat/Chat.vue";

export default {
  components: {
    ChatComponent,
  },
  props: {
    conversationUuid: {
      type: [String, Boolean],
      default: false,
    },
  },
  emits: ["chat-started"],
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    let { chat } = useChat();
    return { asyncOps, asyncOpsReady, asyncStatus, chat };
  },
  data: function () {
    return {
      initialFetchComplete: false,
      initialMessageText: "",
      localConversationUuid: false,
      expanded: true,
      isFullWidth: false,
    };
  },
  computed: {
    finalConversationUuid() {
      if (this.conversationUuid && this.conversationUuid != "") {
        return this.conversationUuid;
      }

      return this.localConversationUuid;
    },
  },
  watch: {},
  created() {
    this.chat.getSupportUserConversationUuid().then((res) => {
      if (res.data.conversationUuid) {
        this.localConversationUuid = res.data.conversationUuid;
      }

      this.initialFetchComplete = true;
    });
  },
  methods: {
    async startSupportChat() {
      let res = await this.chat.messageSupport(this.initialMessageText);

      if (res.hasError) {
        this.$s.ui.notification("core.errorGeneric", "error");
        return;
      }

      this.localConversationUuid = res.data.conversationUuid;
      this.$emit("chat-started", {
        conversationUuid: this.conversationUuid,
        text: this.initialMessageText,
      });

      this.initialMessageText = "";
      return true;
    },
  },
};
</script>

<style scoped lang="scss"></style>
